module.exports = __webpack_public_path__ + "static/media/booked_appt_icon.0c8ed822.svg";